export function formatPhoneNumber(number) {
  return number.replace(/\s+/g, "").trim();
}
